import React from "react";
import "./Projects.css";
import { NavLink } from "react-router-dom";

const projects = [
  {
    title: "Nordic Campus",
    description:
      "Qeeper implemented a comprehensive locker system across the main campus, providing static, dynamic, and guest lockers for students, staff, and visitors. This project streamlined logistics, increased security, and maximized space usage.",
  },
  {
    title: "Corporate Headquarters",
    description:
      "Static and dynamic lockers installed for employees and visitors to streamline storage and internal mail distribution. The project improved overall efficiency and security.",
  },
  {
    title: "Event Venues",
    description:
      "Guest lockers and rental solutions for temporary storage during events, ensuring a smooth and secure visitor experience.",
  },
];

const ProjectsPage = () => (
  <div className="projects-page">
    <header className="page-hero">
      <h1>Our Projects</h1>
      <p>
        Discover how Qeeper smart lockers have transformed spaces across
        different industries.
      </p>
    </header>

    {projects.map((proj, index) => (
      <section
        key={index}
        className={`project-section${index % 2 !== 0 ? " project-section--grey" : ""}`}
      >
        <div className="project-section__inner">
          <h2>{proj.title}</h2>
          <p>{proj.description}</p>
        </div>
      </section>
    ))}

    <section className="page-cta">
      <h2>Start Your Project</h2>
      <p>Let us help you design the perfect smart locker solution.</p>
      <NavLink to="/contact" className="page-cta__button">
        Contact us
      </NavLink>
    </section>
  </div>
);

export default ProjectsPage;
